/// <amd-module name="Environments/Providers/Kubernetes/LogContentReader" />
import { ISection, LogViewer } from "PipelinesUI/LogViewer";
import * as React from "react";
import { ObservableArray } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IVssThemeService } from "VSS/Platform/Theming";
import { CardContent, CustomCard } from "VSSUI/Card";
import { Intersection } from "VSSUI/Intersection";
import { css } from "VSSUI/Util";

export interface ILogContentReaderProperties {
    contentProps?: any;
    contentClassName?: string;
    className?: string;
}

export class LogContentReader extends VssComponent<ILogContentReaderProperties, {}> {
    constructor(props: ILogContentReaderProperties, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): React.ReactNode {
        return this._getLogContentReader();
    }

    private _getLogContentReader(): React.ReactNode {
        const { className, contentClassName, contentProps: props } = this.props;
        const content = (props && props.text) || "";
        const themeService = this.context.pageContext.getService<IVssThemeService>("IVssThemeService");
        themeService.createThemedSelector(".dark-run-logs", t => (t.isDark ? t : themeService.getTheme("ms.vss-web.vsts-theme-dark")));
        const logSection: ISection = {
            hidden: true,
            isExpanded: true,
            getData: () => content,
            title: "k8s-pod-log",
            key: "k8s-pod-log",
            hasData: true
        };

        return (
            <CustomCard className={css(className || "", "k8s-card-padding", "flex-grow", "no-v-padding")}>
                <CardContent className={css(contentClassName || "")} contentPadding={false}>
                    <Intersection>
                        <div className="k8s-reader-outer themed dark-run-logs ">
                            <div className="flex-column">
                                <LogViewer sections={new ObservableArray<ISection>([logSection])} />
                            </div>
                        </div>
                    </Intersection>
                </CardContent>
            </CustomCard>
        );
    }
}
